import FooterNavbar from "../../../footernavbar/FooterNavbar";

const JobsInside = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <div className="container">
          <header>
            <div
              className="page-header p-4"
              style={{
                backgroundImage:
                  "url('https://www.shutterstock.com/image-vector/black-gray-simple-plain-wall-600nw-2443240315.jpg')",
              }}
            >
              <span className="mask bg-gradient-dark opacity-7"></span>
              <div className="container">
                <div className="row">
                  <div className="col-lg-10 mx-auto text-white text-start lh-0">
                    <p className=" text-white text-7xl">
                      Android Engineer
                    </p>
                    <b className=" text-white fs-5">India</b>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div className=" mt-5 container w-80 mx-auto">
            <b className=" text-black fw-normal fs-1">Role overview</b>
            <div className=" mt-3">
              <b className=" text-black fw-bolder fs-6">
                The Community You Will Join:
              </b>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi, minus
                  voluptatibus fugit consequuntur ullam laboriosam, deserunt
                  incidunt excepturi officia eius quo velit nam ipsam sequi!
                </b>
              </div>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi!
                </b>
              </div>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi! Lorem ipsum,
                  dolor sit amet consectetur adipisicing elit. Delectus et
                  maxime, molestias eveniet odit repudiandae quo pariatur eum
                  magni blanditiis fugiat ipsum dolore laboriosam quidem esse
                  ratione nemo harum! Animi.
                </b>
              </div>
            </div>
            <div className=" mt-3">
              <b className=" text-black fw-bolder fs-6">
                The Difference You Will Make:
              </b>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi, minus
                  voluptatibus fugit consequuntur ullam laboriosam, deserunt
                  incidunt excepturi officia eius quo velit nam ipsam sequi!
                </b>
              </div>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi!
                </b>
              </div>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi! Lorem ipsum,
                  dolor sit amet consectetur adipisicing elit. Delectus et
                  maxime, molestias eveniet odit repudiandae quo pariatur eum
                  magni blanditiis fugiat ipsum dolore laboriosam quidem esse
                  ratione nemo harum! Animi.
                </b>
              </div>
            </div>
            <div className=" mt-3">
              <b className=" text-black fw-bolder fs-6">A Typical Day:</b>
              <ul>
                <li>
                  <div className=" mt-3 mb-3">
                    <b className=" text-black fw-normal">
                      Enable Android engineers at Salar to build the best user
                      experiences with DLS (Building Blocks and new UI
                      capabilities) and UI Frameworks
                    </b>
                  </div>
                </li>
                <li>
                  {" "}
                  <div className=" mt-3 mb-3">
                    <b className=" text-black fw-normal">
                      Evolve DLS with flexibility, practicality and long-term
                      scalability in mind that fits Salar’s business needs
                    </b>
                  </div>
                </li>
                <li>
                  {" "}
                  <div className=" mt-3 mb-3">
                    <b className=" text-black fw-normal">
                      Drive investments into new technical capabilities that
                      push the envelope and unlock new product innovation
                    </b>
                  </div>
                </li>
                <li>
                  {" "}
                  <div className=" mt-3 mb-3">
                    <b className=" text-black fw-normal">
                      Identify Design and Engineer product development pain
                      point and constantly improve the development efficiency.
                    </b>
                  </div>
                </li>
                <li>
                  {" "}
                  <div className=" mt-3 mb-3">
                    <b className=" text-black fw-normal">
                      Work alongside iOS and Frontend Web counterparts to
                      deliver on shared objectives.
                    </b>
                  </div>
                </li>
                <li>
                  {" "}
                  <div className=" mt-3 mb-3">
                    <b className=" text-black fw-normal">
                      Support product engineers through community events,
                      training materials, workshops, codelabs, etc.
                    </b>
                  </div>
                </li>
                <li>
                  {" "}
                  <div className=" mt-3 mb-3">
                    <b className=" text-black fw-normal">
                      Contribute to the team’s technical strategy alongside
                      leads to evolve technology choices that scale with Product
                      and Design ambitions.
                    </b>
                  </div>
                </li>
              </ul>
            </div>
            <div className=" mt-3">
              <b className=" text-black fw-bolder fs-6">
              Our Commitment To Inclusion & Belonging:
              </b>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi, minus
                  voluptatibus fugit consequuntur ullam laboriosam, deserunt
                  incidunt excepturi officia eius quo velit nam ipsam sequi!
                </b>
              </div>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi!
                </b>
              </div>
              <div className=" mt-3 mb-3">
                <b className=" text-black fw-normal">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Nostrum earum officiis est voluptatum asperiores, porro
                  dolores, iure, qui sapiente voluptatem animi praesentium. Quas
                  dicta doloribus ad repellendus aperiam fugiat cupiditate?
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Dicta necessitatibus voluptatum unde ad modi! Lorem ipsum,
                  dolor sit amet consectetur adipisicing elit. Delectus et
                  maxime, molestias eveniet odit repudiandae quo pariatur eum
                  magni blanditiis fugiat ipsum dolore laboriosam quidem esse
                  ratione nemo harum! Animi.
                </b>
              </div>
            </div>
            <div className=" pt-5 text-center">
                <button className=" btn btn-lg btn-dark">Apply Now</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobsInside;
